import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { ERROR_OUTLINE_OUTLINED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ErrorOutlineOutlinedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={ERROR_OUTLINE_OUTLINED_GLYPH} />;
